import { render, staticRenderFns } from "./brand-toggle-item.vue?vue&type=template&id=7b62dfd8"
import script from "./brand-toggle-item.vue?vue&type=script&lang=js"
export * from "./brand-toggle-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b62dfd8')) {
      api.createRecord('7b62dfd8', component.options)
    } else {
      api.reload('7b62dfd8', component.options)
    }
    module.hot.accept("./brand-toggle-item.vue?vue&type=template&id=7b62dfd8", function () {
      api.rerender('7b62dfd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/brand-toggle/brand-toggle-item.vue"
export default component.exports